import {IconButton} from '@yandex-delivery/blocks'
import {LeftArrowIcon} from '@yandex-delivery/blocks/icons'

import {classes} from './BackButton.classes'

export function BackButton() {
  function handlePress() {
    window.taxiApp?.call('requestHideWebView', 'token', {})
  }

  // Show the back button only inside the native app webview context.
  // When window.taxiApp is absent (e.g. browser opened via Alice), the button
  // has no working action — hide it instead of rendering a non-functional control.
  if (!window.taxiApp) {
    return null
  }

  return (
    <IconButton className={classes.button} data-theme-invert onPress={handlePress} shape="circle" variant="floating">
      <LeftArrowIcon />
    </IconButton>
  )
}
